import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

// Tabs
import { ComponentsModule } from '../components/components.module';
import { CalendarTab } from './calendar/calendar.tab';
import { FriendsTab } from './friends/friends.tab';
import { GoalsTab } from './goals/goals.tab';
import { JournalTab } from './journal/journal.tab';
import { PassportTab } from './passport/passport.tab';
import { PlacesTab } from './places/places.tab';

@NgModule({
	declarations: [
		CalendarTab,
		FriendsTab,
		GoalsTab,
		JournalTab,
		PassportTab,
		PlacesTab
	],
	imports: [
		ComponentsModule,
		RouterModule,
		IonicModule,
		FormsModule,
		CommonModule
	],
	exports: [
		CalendarTab,
		FriendsTab,
		GoalsTab,
		JournalTab,
		PassportTab,
		PlacesTab
	]
})
export class TabsModule { }
